import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';

@Injectable({
  providedIn: 'root',
})
export class toasterService {
  constructor() {}

  success(msg: string) {
    toast.success(msg);
  }

  warning(msg: string) {
    toast.warning(msg, { duration: 5000 , closeButton: true });
  }

  error(msg: string) {
    toast.error(msg, { duration: 5000 , closeButton: true });
  }
  showFromResponse(res: any, defaultKeyOrMsg?: string, translate?: any) {
    const message = res?.message || res?.data?.message || defaultKeyOrMsg;
    if (!message) return;
    const resolved = translate && typeof translate.instant === 'function' ? translate.instant(message) || message : message;
    toast.success(resolved);
  }
  showFromError(err: any, defaultKeyOrMsg?: string, translate?: any) {
    const message = err?.error?.message || err?.message || defaultKeyOrMsg;
    if (!message) return;
    const resolved = translate && typeof translate.instant === 'function' ? translate.instant(message) || message : message;
    toast.error(resolved, { duration: 5000 , closeButton: true });
  }
}
